



































































































import {Vue, Component, VModel} from 'vue-property-decorator';
import RightSideBar from "@/components/payroll/business/services/RightSideBar.vue";
import PortalTextarea from "@/components/common/PortalTextarea.vue";
import ServiceSliderSelector from "@/components/payroll/business/services/service/ServiceSliderSelector.vue";
import PortalDate from "@/components/common/PortalDate.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import ServiceView from "@/components/payroll/business/services/ServiceView.vue";
import LocationSliderSelector from "@/components/payroll/business/services/locations/LocationSliderSelector.vue";
import {
	CreateServiceRecordPayload,
	InvoiceContact, LocationOption,
	ServiceDTO
} from "@/components/payroll/business/services/ServiceDTO";
import Notifications from "@/state/Notifications";
import {ifValid, processError} from "@/utils/ComponentUtils";
import Application from "@/state/Application";
import ServiceLogOrchestrator from "@/services/ServiceLogOrchestrator";
import RefContactSliderSelector from "@/components/payroll/business/services/contact/RefContactSliderSelector.vue";

@Component({
	components: {
		RefContactSliderSelector,
		LocationSliderSelector,
		ServiceView,
		PortalInput,
		PortalDate,
		ServiceSliderSelector,
		PortalTextarea,
		RightSideBar
	}
})
export default class AssignWorkServiceLog extends Vue {
	@VModel({type: Boolean, default: false})
	private model!: boolean;

	private req = new CreateServiceRecordPayload(
		{
			recipientId: this.$wss.getCurrent.id
		}
	)

	private selectedContact: InvoiceContact | null = null;
	private selectedService: ServiceDTO | null = null;
	private selectedLocation: LocationOption | null = null;

	private createContact = false;
	private createService = false;
	private createLocation = false;

	private selectContact(contact: InvoiceContact) {
		this.selectedContact = contact
		this.req.executorId = this.selectedContact.id
	}

	private selectService(service: ServiceDTO) {
		this.selectedService = service;
		this.req.serviceId = this.selectedService.id
	}

	private selectLocation(location: LocationOption) {
		this.selectedLocation = location
		this.selectedLocation.selected(this.req)
	}

	mount(visible: boolean) {
		if (!visible) {
			this.selectedService = null
			this.selectedLocation = null
		}
	}


	private create() {
		if (this.selectedContact == null) {
			Notifications.error("Please select a contact")
			return
		}
		if (this.selectedService == null) {
			Notifications.error("Please select a service")
			return;
		}
		ifValid(this, () => {
			Application.startLoading()
			ServiceLogOrchestrator.createLog(this.req).then(
				res => {
					Application.stopLoading()
					this.$emit("input", false)
					this.$emit("create", res.data)
				},
				err => processError(err, this)
			)
		})
	}
}
